import { Box, Button, Typography } from '@mui/material';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import CardActions from '@mui/material/CardActions';
import React, { useCallback, useState } from 'react';
import {
  ClinicFbSite,
  FbSiteDoctor,
  IVisitInfo,
} from '../../../interfaces/visit-info.interface';
import { ReactComponent as PersonSuccessSvg } from './person-success.svg';
import { createFeedback } from '../../../api';
import DoctorCard from './doctor-card';

interface FeedbackSuccessFormProps {
  info: IVisitInfo;
  slug: string;
}

export function FeedbackSuccessForm({ info, slug }: FeedbackSuccessFormProps) {
  const [site, setSite] = useState<ClinicFbSite>();

  const onSiteFeedbackClick = useCallback(async (site: ClinicFbSite) => {
    await createFeedback(slug, 5, site.index);

    window.location.replace(site.url);
  }, []);

  const onSiteClick = useCallback(async (site: ClinicFbSite) => {
    if (site?.doctorFeedbackEnabled && site.doctors?.length > 0) {
      setSite(site);
    } else {
      await onSiteFeedbackClick(site);
    }
  }, []);

  return (
    <>
      <Box className='card__image-wrap'>
        {info?.clinic?.fbFeedbackImageUrl ? (
          <CardMedia component='img' image={info.clinic.fbFeedbackImageUrl} />
        ) : (
          <PersonSuccessSvg className='card__image' />
        )}
      </Box>
      <CardContent sx={{ padding: '24px 0' }}>
        <Typography
          sx={{ fontFamily: '"Nunito Sans", sans-serif', mb: 1 }}
          fontSize={16}
          lineHeight={'24px'}
          fontWeight={600}
        >
          {info?.successFeedbackMessage
            ? info.successFeedbackMessage
            : `Будем признательны, если Вы уделите минутку и оставите ${
                site ? 'отзыв о нашем докторе' : 'о нас отзыв'
              }.`}
        </Typography>

        {info.successMessage ? (
          <Typography
            sx={{ fontFamily: '"Nunito Sans", sans-serif', mb: 2 }}
            fontSize={16}
            lineHeight={'24px'}
            fontWeight={600}
          >
            {info.successMessage}
          </Typography>
        ) : (
          <Typography
            sx={{ fontFamily: '"Nunito Sans", sans-serif', mb: 2 }}
            fontSize={16}
            lineHeight={'24px'}
            fontWeight={600}
          >
            {`После публикации отзыва мы перечислим на баланс Вашего телефона ${info?.clinic.smsPrice}
              рублей.`}
          </Typography>
        )}

        <Typography
          sx={{ fontFamily: '"Nunito Sans", sans-serif' }}
          fontSize={12}
          lineHeight='16px'
          fontWeight={800}
        >
          Модерация отзыва может занимать до 5 рабочих дней.
        </Typography>
      </CardContent>

      <CardActions
        disableSpacing={true}
        sx={{
          display: 'grid',
          alignSelf: 'stretch',
          gap: '16px',
          padding: 0,
        }}
      >
        {!site &&
          info.clinic.clinicFbSites.map((site) => {
            return (
              <Button
                key={site.id}
                className='button success'
                variant='outlined'
                onClick={() => onSiteClick(site)}
              >
                <Box
                  component='img'
                  src={site.imageUrl}
                  alt=''
                  sx={{
                    display: 'block',
                    maxHeight: 40,
                    maxWidth: '100%',
                    objectFit: 'contain',
                  }}
                />
              </Button>
            );
          })}

        {site?.doctors?.map((doctor) => (
          <DoctorCard
            key={doctor.id}
            doctor={doctor}
            visitSlug={slug}
            index={site.index}
          />
        ))}

        {site && (
          <Button
            className='button success'
            variant='outlined'
            onClick={() => onSiteFeedbackClick(site)}
          >
            <Box
              component='img'
              src={site.imageUrl}
              alt=''
              sx={{
                display: 'block',
                maxHeight: 40,
                maxWidth: '100%',
                objectFit: 'contain',
              }}
            />
          </Button>
        )}
      </CardActions>
    </>
  );
}
